import { Request } from "@xt/xtbase";
const { XtAxios4 } = Request;

const URL = "/sapi/v4/market/public/";

//获取交易对
export function get_symbol(config?) {
  return XtAxios4.get(URL + `symbol`, config);
}

//获取杠杆交易对
export function get_leverSymbol(config?) {
  return XtAxios4.get(URL + `lever/symbol`, config);
}
